<template>
  <div>
      <div class="columns">
          <div class="column is-narrow">
              <div class="buttons">
                <router-link class="button is-primary" :to="{ params: { time: Number($route.params.time) - 1 }}"> &lt; </router-link>
                <span class="button is-light selected-month" disabled>{{ currentMonth() }}</span>
                <router-link class="button is-primary" :to="{ params: { time: Number($route.params.time) + 1 }}"> &gt; </router-link>
              </div>
          </div>
          <div class="column">
            <a class="button is-info" @click="useTimeTemplate()" v-if="isThereATimeTemplate" style="margin-left: 0.8em;">
                    <span class="icon">
                        <font-awesome-icon :icon="['fas', 'paste']"></font-awesome-icon>
                    </span>
                {{$t("settings.useTimeTemplate")}}
            </a>
          </div>
          <div class="column">
            <ProjectSelect 
                @project="setProject" 
                @projectTask="setProjectLine"
                :all-project-lines="allProjectLines"
                :all-project-desc="allProjectLines"
                :all-projects="allProjects"
                :project-favorites="allProjectLinesFavorites"
                :custom-projects="orgSettings.customProjects"
                :custom-project-lines="orgSettings.customProjectLines"
                :use-custom-projects="!orgSettings.ERPenabled"
                :use-standard-project="orgSettings.useStandardProject"
                :standard-project="orgSettings.standardProject"
            ></ProjectSelect>
          </div>
        </div>
    <table class="table month is-fullwidth">
        <thead>
            <tr>
                <th>
                    {{ $t("registrations.date") }}
                </th>
                <th>
                    {{ $t("registrations.from") }}
                    <span style="margin-left:4.2em;">{{ $t("registrations.to") }}</span>
                    <span style="margin-left:4.8em">{{ $t("registrations.noHours") }}</span>
                </th>
                <th style="width: 45%;">
                    {{ $t("registrations.comment")}}
                </th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td>
                    <a @click="sendMonthRegForApproval()" class="button is-small is-primary">
                        {{$t("input.sendForApp")}}
                    </a>
                    <p class="help">{{$t("settings.allMonthRegsText")}} </p>
                </td>
                <td></td>
                <td></td>
            </tr>
        </tfoot>
        <tbody>
            <tr v-for="day in daysInMonth" v-bind:key="day" v-bind:class="{  weekendStyle: isWeekend(momentDate(day-1)) || calendar.methods.isDateAholiday(momentDate(day-1),dkHolidays)}">
                <td style="width:50px">
                    {{ day }}. <span class="help">{{ returnWeekday(momentDate(day-1))}}</span>
                </td>
                <td>
                    <TimeMonthInput 
                        :month-date="momentDate(day-1)"
                        @registered-hours="getRegHours($event, momentDate(day-1))"
                    />
                </td>
                <td>
                    <registration-comment type="month" :day="momentDate(day-1)" /> 
                </td>
            </tr>
        </tbody>
    </table>
  </div>
</template>

<script>
import firebase from '@/firebase'
import moment,{ calendarFormat } from 'moment'
import _ from 'lodash'
import TimeMonthInput from '@/components/month/TimeMonthInput.vue'
import ProjectSelect from '@/components/ProjectSelect'
import RegistrationComment from '@/components/inputs/RegistrationComment.vue'

import calendar from '../../utils/calendar'
import templates from '../../utils/templates.vue'

export default {
  name: 'TimeMonthTable',
  components: {
    TimeMonthInput,
    ProjectSelect,
    'registration-comment': RegistrationComment
  },
   data: function() {
       return {
        error: false,
        timeTemplate: [],
        selectedProject: false,
        selectedProjectLine: false,
       }
   },
    firebase: function() { 
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        const userid = JSON.parse(localStorage.getItem('profile')).user_id;
        return {
            allRegistrations: {
                source: firebase.database().ref('/organisations/' + tenantid + '/registrations/' + userid).orderByChild('projectCombined'),
            },
            allProjects: {
                source: firebase.database().ref('/organisations/' + tenantid + '/JobList'),
            },
            allProjectLines: {
                source: firebase.database().ref('/organisations/' + tenantid + '/JobTaskLines'),
            },
            allProjectLinesFavorites: {
                source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid + '/JobTaskLines'),
            },
            dkHolidays: {
                source: firebase.database().ref('/holidays/dk/' + moment().year()),
            },
            orgSettings: {
                source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
                asObject: true,
            },
            personalSettings: {
                source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid),
                asObject: true,
            }
        }
    },
    watch: {
        '$route' (to, from) {
            if(to.params.time !== from.params.time) {
                //TODO:fix sot that reload is not necessary
                location.reload()
            }
        }
    },
    beforeCreate: function() {
        this.calendar = calendar
        this.templates = templates
    },
    computed: {
        isThereATimeTemplate() {
            if(this.personalSettings.timeTemplate) { return true } else { return false }
        },
        allRegistrationsStandardProject() {
            let projectCombined = {}
            const projectString = this.orgSettings.standardProject.no + '-' + this.orgSettings.standardProject.task_no
            projectCombined[projectString] = [{
                isCustomProject:true,
                project:this.orgSettings.standardProject.no,
                projectCombined: projectString,
                projectLine:this.orgSettings.standardProject.task_no,
            }]
            return projectCombined
        },
        allRegistrationsUnique: function () {
            return _.groupBy(this.allRegistrations, 'projectCombined')
        },
        daysInMonth() {
            var daysInMonth = [];

            var monthDate = moment().month(this.$route.params.time - 1).startOf('month')

            _.times(monthDate.daysInMonth(), function (n) {
                daysInMonth.push(monthDate.format('D'));
                monthDate.add(1, 'day');
            });
            return daysInMonth
        },
    },
    methods: {
        returnWeekday(day) {
            moment.locale(this.$i18n.locale)
            return moment(day).format('ddd')
        },
        isWeekend(day) {
            if(moment(day).weekday() === 5 || moment(day).weekday() === 6) {
                return true
            } else { return false }
        },
        deletePreviousRegs(day) {
            // find all registration on date and delete them
            const regsToDelete = _.filter(this.allRegistrations, {'date': day})
            _.forEach(regsToDelete, (registration) => {
                if(registration.time > 0 && registration.isApproved === false) {
                    this.$firebaseRefs.allRegistrations.child(registration['.key']).remove()
                }
            })
        },
        getRegHours(time, day) {
            this.deletePreviousRegs(day)
            const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
            const userid = JSON.parse(localStorage.getItem('profile')).user_id;
            const projectNo = this.selectedProject || this.orgSettings.standardProject.no
            const projectLine =  this.selectedProjectLine || this.orgSettings.standardProject.task_no
            const projectString = this.orgSettings.standardProject.no + '-' + this.orgSettings.standardProject.task_no

            const reg = {
                time: time.total,
                fromHour: moment(time.from).format("HH:mm"),
                toHour: moment(time.to).format("HH:mm"),
                isCustomProject: !this.orgSettings.ERPenabled,
                date: day,
                project: projectNo,
                projectLine: projectLine,
                projectCombined: projectString,
                uid: userid,
                tenantid: tenantid,
                quarter: moment(day).quarter(),
                isApproved: false,
                sentForApproval: false,
                timestamp: moment().format()
            }
            this.$firebaseRefs.allRegistrations.push(reg)
        },
        setProject: function(projectNo) {
        this.selectedProject = projectNo;
        },
        setProjectLine: function(projectLine) {
        this.selectedProjectLine = projectLine;
        },
        currentMonth() {
            moment.locale(this.$i18n.locale)
            const month = this.$route.params.time - 1;
            return moment().month(month).format('MMMM')
        },
        getAllWeeks(year, month) {
                const firstDayOfMonth = moment(`${ year }-${ month }`, 'YYYY-MM-DD');
                let weekIndices = [];

                let currentDay = moment(firstDayOfMonth, 'YYYY-MM-DD');
                weekIndices.push(currentDay.isoWeek());

                while(currentDay.month() === firstDayOfMonth.month()) {
                    currentDay.add(1, 'weeks');
                    weekIndices.push(currentDay.isoWeek());
                }

                return weekIndices;
        },
        useTimeTemplate() {
            let regs = []
            let selectedMonth = this.$route.params.time - 1
            const startOfMonth = moment().month(selectedMonth).startOf('month').format('YYYY-MM-DD');
            const endOfMonth   = moment().month(selectedMonth).endOf('month').format('YYYY-MM-DD');
            console.log("startOfMonth: " + startOfMonth)
            console.log("endOfMonth: " + endOfMonth)
            const weeksInMonth = this.getAllWeeks(moment().format('YYYY'), this.$route.params.time)
            _.forEach(weeksInMonth, (week) => {
                const weekRegs = this.templates.methods.useTimeTemplate(week, this.orgSettings, this.personalSettings, this.$i18n.locale)
                regs.push(weekRegs)
            })
            const regsArray = _.flatMap(regs)
            const filteredArray = _.filter(regsArray, (reg) => {
                return moment(reg.date).isBetween(startOfMonth, endOfMonth, 'day', '[]')
            })
            _.forEach(filteredArray, (registration) => {
                this.$firebaseRefs.allRegistrations.push(registration)
            })
        },
        dateSum: function(date) {
        // sum time per date from week table
        const sum = _.sumBy(_.filter(this.allRegistrations, {'date': date}), 'time');
        if (sum > 0) {
            return sum;
        } else {
            return 0;
        }
        },
        setProject: function(projectNo) {
            this.selectedProject = projectNo;
        },
        momentDate: function(addDays) {
            if(this.$route.params.time) {
                //return moment().isoWeek(this.$route.params.time).startOf('isoWeek').add(addDays, 'days').format('YYYY-MM-DD');
                return moment().month(this.$route.params.time - 1).startOf('month').add(addDays, 'days').format('YYYY-MM-DD');
            } else {
                // return moment().isoWeek(this.currentWeek).startOf('isoWeek').add(addDays, 'days').format('YYYY-MM-DD');
                return moment().startOf('month').add(addDays, 'days').format('YYYY-MM-DD');
            }
        },
        sendMonthRegForApproval: function() {
            let endOfMonth;
            if(this.$route.params.time) {
                endOfMonth = moment().month(this.$route.params.time).endOf('month').format('YYYY-MM-DD');
            } else {
                endOfMonth = moment().month().endOf('month').format('YYYY-MM-DD');
            }
            const registrations = _.filter(this.allRegistrations, function(o) {
                if((o.isApproved === false || !o.isApproved ) && o.date < endOfMonth) {
                    return o;
                } 
            });

            //   for each registration push an approval in firebase
            let updates = {};
            for (var i = 0, len = registrations.length; i < len; ++i) {
                // add update information to array
                updates[registrations[i]['.key'] + '/sentForApproval'] = true;
            }
            try {
                this.$firebaseRefs.allRegistrations.update(updates)
            } catch(error) {
                this.error = error
            } finally {
                if(!this.error) {
                    if(_.find(registrations, {'sentForApproval': false})) {
                        this.$snotify.success('Sendt til godkendelse', {
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true
                            });
                        } else {
                        this.$snotify.warning('Ingen registreringer der kan sendes til godkendelse', {
                            showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true
                            });                    
                        }
                }
            }
        }
    }
}
</script>
<style>
    .selected-month {
        text-align: center;
        text-transform: capitalize;
    }
    .weekendStyle {
        background-color: #fafafa;
    }
</style>

